import React, { useState } from 'react';

const AdminDashboard = () => {
  const handleLogout = async () => {
    try {
      const response = await fetch("server.php?resource=logout", { method: "GET" });
      const data = await response.json();
      console.log("Logout Response:", data);

      if (data.message.toLowerCase().includes("logout successful")) {
        window.location.href = "/login_receipt"; // Redirect to login page after logout
      } else {
        alert("Logout failed. Please try again.");
      }
    } catch (error) {
      console.error("Logout Error:", error);
      alert("Logout failed. Please check your connection.");
    }
  };

  return (
    <>
      <style>{`
        body {
          background: linear-gradient(135deg, #cfd9df, #e2ebf0);
        }
        .dashboard-container {
          max-width: 1100px;
          margin: auto;
          padding: 20px;
        }
        .card {
          transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
        }
        .card:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
        .card i {
          font-size: 50px;
          color: #007bff;
          margin-bottom: 10px;
        }
      `}</style>
      <div className="container dashboard-container">
        <h2 className="text-center mb-4">Admin Dashboard</h2>
        <div className="row">
          <div className="col-md-4">
            <div className="card text-center p-4">
              <i className="fas fa-envelope"></i>
              <h5>Contact Us</h5>
              <p>Manage and respond to inquiries.</p>
              <a href="contact.html">
                <button className="btn btn-primary">Go to Contact</button>
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card text-center p-4">
              <i className="fas fa-briefcase"></i>
              <h5>Career</h5>
              <p>Manage job postings and applications.</p>
              <a href="career.html">
                <button className="btn btn-success">Go to Career</button>
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card text-center p-4">
              <i className="fas fa-quote-left"></i>
              <h5>Quote</h5>
              <p>Handle customer quote requests.</p>
              <a href="quote.html">
                <button className="btn btn-warning">Go to Quotes</button>
              </a>
            </div>
          </div>
          <div className="col-md-4 mt-3">
            <div className="card text-center p-4">
              <i className="fa-solid fa-robot"></i>
              <h5>Chat Bot</h5>
              <p>Handle customer Chat requests.</p>
              <a href="chatbot.html">
                <button className="btn btn-warning">Go to Chatbot</button>
              </a>
            </div>
          </div>
          <div className="col-md-4 mt-3">
            <div className="card text-center p-4">
              <i className="fas fa-graduation-cap"></i>
              <h5>Laura-Tek</h5>
              <p>Handle Enrolled students.</p>
              <a href="laura_dashboard.html">
                <button className="btn btn-primary">Go to Laura-Tek</button>
              </a>
            </div>
          </div>
        </div>
        {/* Logout Button (Fixed) */}
        <div className="text-center mt-4">
          <button className="btn btn-danger" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;